import { Routes } from '@angular/router';

export const appRoutes: Routes = [
    { path: 'login', loadChildren: './modules/login/login.module#LoginModule' },
    { path: '', loadChildren: './modules/distribution/distribution.module#DistributionModule' },
    { path: '**', redirectTo: '', pathMatch: 'full' }
];



// WEBPACK FOOTER //
// ./src/app/app.routing.ts